import React from "react";
import SectionShell from "../layout/SectionShell";
import { contactData } from "../../mock/portfolioData";
import { Linkedin, LocateFixed, LocateIcon, LucidePhoneCall, Mail, Phone } from "lucide-react";

export function ContactSection() {
  return (
    <SectionShell id="contact" title="Contact" kicker="Reach out">
      <div className="grid gap-8 md:grid-cols-[minmax(0,1.4fr)_minmax(0,1.2fr)] items-start">
        <div className="space-y-3 text-sm text-slate-300">
          <p>{contactData.note}</p>
          <p className="text-xs text-slate-500">
            I&apos;m most responsive over email, but you can also reach me via
            LinkedIn or phone for opportunities around AI search, RAG systems,
            and enterprise chatbots.
          </p>
        </div>

        <div className="retro-card space-y-3 rounded-2xl border border-slate-800 bg-slate-900/70 p-5 text-sm text-slate-100">
          <div className="flex items-center gap-2 text-slate-100">
            <Mail className="h-4 w-4 text-cyan-300" />
            <a
              href={`mailto:${contactData.email}`}
              className="font-medium underline-offset-2 hover:underline"
            >
              {contactData.email}
            </a>
          </div>
          {/* <div className="flex items-center gap-2 text-slate-100">
            <Phone className="h-4 w-4 text-cyan-300" />
            <span className="font-medium text-xs text-slate-400">{contactData.phone}</span>
          </div> */}
          <div className="flex items-center gap-2 text-slate-100">
            <LocateFixed className="h-4 w-4 text-cyan-300" />
            <span className="font-medium text-xs text-slate-400">{contactData.location}</span>
          </div>
          <div className="flex items-center gap-2 text-slate-100">
            <Linkedin className="h-4 w-4 text-cyan-300" />
            <a
              href={contactData.linkedin}
              target="_blank"
              rel="noreferrer"
              className="font-medium text-slate-50 underline-offset-2 hover:underline"
            >
              Ajay Sunil
            </a>
          </div>
        </div>
      </div>
    </SectionShell>
  );
}

export default ContactSection;
